import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CoachAvatar } from "@/components/CoachAvatar";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await register(name, email, password);
      navigate("/dashboard");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] grain flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-10" data-testid="auth-logo">
          <CoachAvatar size="sm" />
          <div className="leading-tight text-center">
            <div className="font-serif-display text-xl text-[#1C221D]">India Sadie</div>
            <div className="font-serif-display italic text-xs text-[#5C6A61]">Live the life you've always wanted.</div>
          </div>
        </Link>
        <div className="bg-white rounded-3xl p-8 md:p-10 border border-[#2A3B32]/10 shadow-[0_20px_60px_rgba(42,59,50,0.06)]">
          <h1 className="font-serif-display text-4xl text-[#1C221D]">Begin</h1>
          <p className="text-[#5C6A61] mt-2">A soft place for the hard questions.</p>
          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <div>
              <label className="eyebrow text-[#5C6A61] block mb-2">Your name</label>
              <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                data-testid="register-name"
                className="w-full px-4 py-3 rounded-xl border border-[#2A3B32]/15 bg-[#FDFBF7] focus:outline-none focus:border-[#2A3B32] focus:ring-2 focus:ring-[#81B29A]/30 transition-colors"
              />
            </div>
            <div>
              <label className="eyebrow text-[#5C6A61] block mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="register-email"
                className="w-full px-4 py-3 rounded-xl border border-[#2A3B32]/15 bg-[#FDFBF7] focus:outline-none focus:border-[#2A3B32] focus:ring-2 focus:ring-[#81B29A]/30 transition-colors"
              />
            </div>
            <div>
              <label className="eyebrow text-[#5C6A61] block mb-2">Password</label>
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="register-password"
                className="w-full px-4 py-3 rounded-xl border border-[#2A3B32]/15 bg-[#FDFBF7] focus:outline-none focus:border-[#2A3B32] focus:ring-2 focus:ring-[#81B29A]/30 transition-colors"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="register-submit"
              className="w-full py-3.5 rounded-full bg-[#2A3B32] text-[#FDFBF7] hover:-translate-y-0.5 active:scale-95 transition-transform duration-200 disabled:opacity-60"
            >
              {loading ? "Creating…" : "Create account"}
            </button>
          </form>
          <div className="mt-6 text-center text-sm text-[#5C6A61]">
            Already have one?{" "}
            <Link to="/login" className="text-[#2A3B32] underline underline-offset-4" data-testid="goto-login">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
